var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPrescription = function SvgIconPrescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.75 3.75a1 1 0 0 1 1-1h4.5a5.125 5.125 0 0 1 1.454 10.04l3.421 3.42 1.918-1.917a1 1 0 0 1 1.414 1.414l-1.918 1.918 1.918 1.918a1 1 0 0 1-1.414 1.414l-1.918-1.918-1.918 1.918a1 1 0 0 1-1.414-1.414l1.918-1.918L10.086 13H7.75v5a1 1 0 1 1-2 0zm2 7.25h3.5a3.125 3.125 0 1 0 0-6.25h-3.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPrescription;